import $ from 'jquery';
import { Controller, EffectFade, Navigation, Swiper } from 'swiper';
import { $Elements, Classes, Durations, Events } from './constants';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Slider for wines presentation ----------

	$('.wine-presentation-slider-section').each(function() {

		const carousel = this.querySelector('.section-carousel');
		const thumbnails = this.querySelector('.section-thumbnails');

		if(carousel && thumbnails) {

			let thumbnailsSwiper = null;
			let mainSwiper = null;

			if(!thumbnails.swiper) {

				thumbnailsSwiper = new Swiper(thumbnails, {
					modules: [Controller],
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					grabCursor: true,
					watchSlidesProgress: true,
					centerInsufficientSlides: true,
					slideToClickedSlide: true,
					slidesPerView: 'auto',
					on: {
						afterInit: swiper => {
							$(swiper.el).find('.content-column:first-child').addClass(Classes.active);
							$(swiper.el).find('.content-column').each(function(index) {

								$(this).on('click', () => {
									$(swiper.el).find('.content-column').removeClass(Classes.active);
									$(this).addClass(Classes.active);

									if(mainSwiper) {
										mainSwiper.slideTo(index);
									}
								});
							});
						}
					}
				});
			}

			if(!carousel.swiper) {

				mainSwiper = new Swiper(carousel, {
					modules: [Controller, EffectFade],
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					grabCursor: true,
					watchSlidesProgress: true,
					slideToClickedSlide: true,
					slidesPerView: 'auto',
					effect: 'fade',
					on: {
						activeIndexChange: swiper => {

							if(thumbnailsSwiper) {
								$(thumbnailsSwiper.el).find('.content-column').removeClass(Classes.active);
								$(thumbnailsSwiper.el).find('.content-column:nth-child(' + (swiper.activeIndex + 1) + ')').addClass(Classes.active);
							}
						}
					}
				});
			}

			if(mainSwiper && thumbnailsSwiper) {
				mainSwiper.controller.control = thumbnailsSwiper;
				thumbnailsSwiper.controller.control = mainSwiper;
			}
		}
	});

	// ---------- Slider for wine bottles ----------

	$('.wines-slider-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				grabCursor: true,
				watchSlidesProgress: true,
				centerInsufficientSlides: true,
				slideToClickedSlide: true,
				slidesPerView: 'auto',
				on: {
					afterInit: swiper => {
						$(swiper.el).find('.content-column').each(function(index) {

							$(this).on('click mouseenter', () => {
								$(swiper.el).find('.content-column').removeClass(Classes.active);
								$(this).addClass(Classes.active);
								swiper.slideTo(index);
							});
						});
					},
					activeIndexChange: swiper => {
						$(swiper.el).find('.content-column').removeClass(Classes.active);
						$(swiper.el).find('.content-column:nth-child(' + (swiper.activeIndex + 1) + ')').addClass(Classes.active);
					}
				}
			});
		}
	});

	// ---------- Slider for Articles ----------

	$('.other-articles-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				modules: [Navigation],
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				grabCursor: true,
				watchSlidesProgress: true,
				centerInsufficientSlides: true,
				slideToClickedSlide: true,
				slidesPerView: 'auto',
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

});


